import { useMemo, useState } from "react";
import { useAddBalance, usePlans } from "../lib/queries";
import { Loading } from "./Loading";
import { useToast } from "./Toast";

interface Props {
  participant: { id: string; name: string };
  kind: "single" | "pack";
  onClose: () => void;
}

export function AddBalanceSheet({ participant, kind, onClose }: Props) {
  const plansQ = usePlans();
  const addBalance = useAddBalance();
  const toast = useToast();
  const [planId, setPlanId] = useState<string | null>(null);
  const [paid, setPaid] = useState("");
  const [busy, setBusy] = useState(false);

  const plans = useMemo(
    () => (plansQ.data ?? []).filter((p) => p.kind === kind),
    [plansQ.data, kind],
  );

  const title = kind === "single" ? "Разове" : "Абонемент";

  return (
    <div className="fixed inset-0 z-20 bg-black/40 flex items-end" onClick={onClose}>
      <div className="bg-tg-bg w-full rounded-t-2xl p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-semibold">{title} для {participant.name}</h2>
        {plansQ.isLoading ? <Loading /> : (
          <div className="space-y-2">
            {plans.map((p) => (
              <button
                key={p.id}
                className={`w-full card text-left ${planId === p.id ? "ring-2 ring-tg-link" : ""}`}
                onClick={() => setPlanId(p.id)}
              >
                <div className="font-medium">{p.name}</div>
                <div className="text-tg-hint text-sm">
                  {p.sessions_count} {p.kind === "single" ? "заняття" : "занять"}
                </div>
              </button>
            ))}
          </div>
        )}
        <input
          className="w-full bg-tg-secondary rounded-xl px-3 py-2"
          placeholder="Сума оплати, ₴ (необов'язково)"
          inputMode="decimal"
          value={paid}
          onChange={(e) => setPaid(e.target.value)}
        />
        <div className="flex gap-2">
          <button className="btn-secondary flex-1" onClick={onClose}>Скасувати</button>
          <button
            className="btn-primary flex-1"
            disabled={!planId || busy}
            onClick={async () => {
              setBusy(true);
              try {
                await addBalance.mutateAsync({
                  participant_id: participant.id,
                  plan_id: planId!,
                  paid_amount: paid ? Number(paid) : null,
                });
                onClose();
              } catch (e) {
                toast.error((e as Error).message);
              } finally {
                setBusy(false);
              }
            }}
          >Додати</button>
        </div>
      </div>
    </div>
  );
}
